module.exports = __webpack_public_path__ + "img/天府新区半山艾马仕幼儿园.e9d0edca.jpg";